import '../../../styles/index.css'
import './CardCategoria.css';
import { useNavigate } from 'react-router-dom';

function CardCategoria({icone, categoria}) {

  const navigate = useNavigate();

  return (

    <div className='card-categoria' onClick={() => navigate(`/Pesquisa/${categoria}`)} data-cy="card-categoria-btn">

      <img src={icone} alt="Icone da Categoria" />

      <p className='bt2 text-center'>{categoria}</p>

    </div>

  );
}

export default CardCategoria;
